/* Global imports. */
import React from "react";

import EventCard from "@components/EventCard";

import KontentEvent from "@models/kontent/KontentEvent"

interface Props {
  events: KontentEvent[];
}

const EventCollection = ({ events }: Props) => <ol className="event-list js-event-list !ml-0 !list-none">
{events.map((item, i) => {
  return <EventCard event={item} key={i} />;
})}
</ol>;

export default EventCollection;
